import '../../../rc-tree/es/Tree.js';
import ContextTreeNode from '../../../rc-tree/es/TreeNode.js';
import DirectoryTree from './DirectoryTree.js';
import TreePure from './Tree.js';
const Tree = TreePure;
Tree.DirectoryTree = DirectoryTree;
Tree.TreeNode = ContextTreeNode;
var Tree$1 = Tree;
export { Tree$1 as default };
//# sourceMappingURL=index.js.map
